import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";

export let commonInitialState = {
    id: null,
    model: null,
    all: [],
    query: '',
    serverPagination: {
        page: 1,
        rowsNumber: 0,
        descending: false,
        itemsPerPage: 25,
    },
    totalNumber: 0,
    filters: {},
    loading: false,
    modelData: {},
    exportRows: 10,
    exportName: '',
};

export let initialState = {
    loading: false,
    query: '',
    filters: {},
    data: [],
    links: {},
    totalItems: null,
    totalItemsLoading: false,
    meta: {},
    initialFilters: {},
    serverPagination: {
        page: 1,
        rowsNumber: 0,
        descending: false,
        itemsPerPage: 25
    },
};


export let initialActions = {
    async fetchData({state, commit}, type = null) {
        commit('setLoading', true);
        const pagination = state.serverPagination;
        let serverParams = {
            ...state.filters,
            ...state.initialFilters,
            paginate: true,
            exportRows: state.exportRows,
            exportName: state.exportName,
            query: state.query,
            rowsPerPage: pagination.itemsPerPage,
            sortBy: pagination.sortBy ? pagination.sortBy[0] : null,
            descending: pagination.sortDesc ? pagination.sortDesc[0] : null,
        };
        serverParams = {...serverParams, ...state.filters};
        // console.log(serverParams);
        let response = null;
        if ((state.links.prev || state.links.next)  && type && typeof type !== "number" && type !== 'null') {
            let link = null;
            type = type.toLowerCase() || type;
            if (type === 'prev') {
                link = state.links.prev;
            } else if (type === 'next') {
                link = state.links.next
            }
            try {
                response = await Http.get(link, {
                    params: serverParams
                });
                commit('setData', response.data)
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                throw e;
            }

        } else {
            try {
                response = await Http.get(VERSIONED_API_URL + '/' + state.url_name, {
                    params: serverParams
                });
                commit('setTotalItems', null);
                commit('setData', response.data)
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                throw e;
            }
        }
    },
    async exportData({state}, items) {
        try {
            const pagination = state.serverPagination;
            let serverParams = {
                ...state.filters,
                ...state.initialFilters,
                exportRows: items.rows,
                exportName: items.name,
                query: state.query,
                rowsPerPage: pagination.itemsPerPage,
                sortBy: pagination.sortBy ? pagination.sortBy[0] : null,
                descending: pagination.sortDesc ? pagination.sortDesc[0] : null,
                page: state.meta.page
            };
            serverParams = {...serverParams, ...state.filters};
            if (serverParams.date_range)
                serverParams.date_range = JSON.stringify(serverParams.date_range);
            // console.log(serverParams);

            // VERSIONED_API_URL
            let url = state.meta.path + '/export';
            const res = await Http.post(`${VERSIONED_API_URL}/${state.url_name}/export`, serverParams);
            console.log(res);
            window.open(res.data.url, "_blank");
        } catch (e) {
            throw e;
        }


    },
    async getCount({state, commit}) {
        let serverParams = {
            ...state.filters,
            paginate: true,
            query: state.query,
        };
        serverParams = {...serverParams, ...state.filters};
        let count_params = {...serverParams, ...state.filters, do_count: true};
        commit('setTotalItemsLoading', true);
        Http.get(VERSIONED_API_URL + '/' + state.url_name, {
            params: count_params
        }).then((res) => {
            commit('setTotalItems', res.data);
            commit('setTotalItemsLoading', false);
        });
    },
    setLoading(state, loading) {
        state.commit('setLoading', loading)
    },
    resetState({commit}) {
        commit('resetState')
    }
};

export let initialMutations = {
    setData(state, items) {
        let data = items.data;
        data = data.map((item, index) => {
            item.s_no = (items.meta.current_page - 1) * items.meta.per_page + (index + 1);
            return item;
        });
        state.meta = items.meta;
        state.data = data;
        state.links = items.links;
    },
    setServerPagination(state, item) {
        state.serverPagination = item;
    },
    setServerQuery(state, query) {
        state.query = query;
    },
    setFilter(state, filters) {
        state.filters = filters;
    },
    setTotalItems(state, totalItems) {
        state.totalItems = totalItems;
    },
    setTotalItemsLoading(state, loading) {
        state.totalItemsLoading = loading;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setInitialFilters(state, filters) {
        state.initialFilters = filters;
    }
};
